module.exports = __webpack_public_path__ + "media/images/voice-logo-small-ba8b71cb9339dfc40397a0d8491d32a1.png";